export function TableFooter({
  count,
  noun,
}: {
  readonly count: number;
  readonly noun: string;
}) {
  return (
    <>
      <span>
        Showing {count === 0 ? 0 : 1}-{count} of {count} {noun}
        {count === 1 ? "" : "s"}
      </span>
      <div className="flex gap-1">
        <button
          className="flex h-[26px] w-7 items-center justify-center rounded border border-border text-xs"
          type="button"
        >
          1
        </button>
      </div>
    </>
  );
}
